export default "__VITE_ASSET__BGumzYgk__"